import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { EventBus } from '@/services/eventbus.js';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
export default {
  name: 'ViewPublicMap',
  mixins: [MapViewMixin],
  data: function () {
    return {
      apiKeyError: false,
      apiKey: null,
      twinId: null,
      hideBottomBar: false,
      clusterDistance: 50,
      footerData: {
        de: {},
        en: {}
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    showBottomBar() {
      if (this.hideBottomBar) {
        return false;
      }
      return this.floorList.length > 0 || this.buildingFloorList && this.buildingFloorList.length > 0;
    }
  },
  watch: {
    $route() {
      this.clusterDistance = this.getIntFromQueryParam('clusterdistance', 50);
      this.enableZoomLock = this.calcBoolQueryParam('zoomlock');
      this.hideBottomBar = this.calcBoolQueryParam('hidebar');
    }
  },
  async created() {
    this.apiKey = this.$route.params.key;
    this.twinId = this.$route.params.twinId;
    this.clusterDistance = this.getIntFromQueryParam('clusterdistance', 50);
    this.enableZoomLock = this.calcBoolQueryParam('zoomlock');
    this.hideBottomBar = this.calcBoolQueryParam('hidebar');
    ApiService.instance.interceptors.request.use(config => {
      config.headers['X-API-Key'] = this.apiKey;
      return config;
    });
    try {
      await this.$store.dispatch('authentication/verify', this.apiKey);
      const isShared = await ApiService.digitalTwinIsShared(this, this.twinId).then(res => {
        return res.isShared;
      }).catch(error => {
        console.error(error);
      });
      if (!isShared) {
        throw new Error('TWIN_SHARING_NOT_ENABLED');
      }
      if (!this.$store.state.app.permissions) {
        await this.$store.dispatch('app/loadPermissions');
      }
      EventBus.$emit('refresh-branding');
    } catch (e) {
      this.apiKeyError = true;
    }
    if (!this.apiKeyError) {
      this.loadInitialData();
    }

    // Get Footer Data for Datenschutzhinweis and Impress
    this.footerData = this.$store.state.app.footer;
  },
  methods: {
    calcBoolQueryParam(paramName = 'zoomlock') {
      const queryParams = (window.location.href || '').split('?');
      if (queryParams.length >= 2) {
        return queryParams[1].split('&').findIndex(v => new RegExp(`(^${paramName}(=true|$))`, 'gi').exec(v) !== null) >= 0;
      }
      return false;
    },
    fetchTwinData() {
      this.hasLoadedInitially = false;
      if (this.$refs.mapInstance) {
        this.$refs.mapInstance.hasLoadedMarkers = false;
      }
      this.loadTree();
      const selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      return ApiService.digitalTwinFetchGeoMetaInfos(this, selectedRootTwinId).then(data => {
        this.stateKeys = data.keyList;
        this.twinTags = data.tagList;
        this.floorList = data.floorList;
      }).catch(error => {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    getClusterContent(cluster, bounds) {
      if (!cluster) {
        this.selectedCluster = {};
        return;
      }
      const selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      // forward-compatability; new API only has search-items and no designated tag-filter
      const searchItems = [this.selectedTwinTag ? {
        variable: 'tag',
        search: this.selectedTwinTag
      } : undefined];
      ApiService.digitalTwinGetGeoClusterContent(this, cluster.id, selectedRootTwinId, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], [],
      // filters
      searchItems, this.excludeZones, this.clusterDistance).then(data => {
        this.selectedCluster = {
          ...cluster,
          items: data.dtwins
        };
      }).catch(error => {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree(bounds = undefined) {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      const selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      // forward-compatability; new API only has search-items and no designated tag-filter
      const searchItems = this.selectedTwinTag ? [{
        variable: 'tag',
        search: this.selectedTwinTag
      }] : [];
      return ApiService.digitalTwinFetchGeoClusters(this, selectedRootTwinId, this.indoorFloorDtwinId, bounds, this.selectedStateKey, searchItems, {
        excludeZones: this.excludeZones,
        hideStatelessPolygons: this.hideStatelessPolygons,
        clusterDistance: this.clusterDistance
      }).then(data => {
        this.calculateBoundingBox(data);
        this.markerItems = data.dtwins;
      }).catch(error => {
        console.error('Error loading map-twin-clusters', error);
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};